<script setup lang="ts">
import type { MenuItem } from '~/types'

interface Props {
  menuItem: MenuItem.Model
}

const props = defineProps<Props>()
const { children } = useMenuItem(props.menuItem)

const columnCustomClass = computed<Record<string, string>>(() => props.menuItem.data?.customClass || {})
</script>

<template>
  <div
    :class="columnCustomClass"
    class="column-menu-item"
  >
    <ul class="column-menu-item__list">
      <li>
        <span
          v-if="menuItem.name"
          class="column-menu-item__title"
        >
          {{ menuItem.name }}
        </span>
      </li>
      <li class="column-menu-item__submenu-item">
        <MenuList
          :menu-items="children"
          class="column-menu-item__submenu"
        />
      </li>
    </ul>
  </div>
</template>

<style scoped lang="scss">
.column-menu-item {
  &__title {
    @apply text-[15px] text-white bg-primary font-semibold mb-[20px] leading-[1] block text-left;
  }

  &--hidden-name &__title {
    @apply hidden;
  }
}
</style>
